import { StyleSheet } from 'react-native';

import { lightGrey } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        height: 36,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        paddingHorizontal: 16,
    },
    rightContainer: {
        marginLeft: 'auto',
    },
    passed: {
        backgroundColor: lightGrey(0.1),
    },
    rightImage: {
        width: 24,
        height: 24,
    },
    option: { flex: 1 },
});

export default styles;
